module.exports = __webpack_public_path__ + "static/media/camion.0568751b.png";